<app-navbar></app-navbar>
<router-outlet></router-outlet>
<div class="px-4 my-2">
    
</div>